export default "__VITE_ASSET__CiozGepb__"